import Collection from '@jimmyboys/liita-ui/dist/components/Collection'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import ExpandableWidget from 'components/ExpandableWidget/ExpandableWidget'
import User from 'models/User'
import React from 'react'
import { Link } from 'react-router-dom'
import { useFetchList } from 'store'
import styles from './ContextualController.module.sass'

const UserRow = (props) => {
	const { data, ...attributes } = props
	const { i18n } = useGlobal()
	return (
		<div {...attributes} className={styles['row']}>
			<h5>{data?.name}</h5>
			<Link className={styles['large']} to={`/users/${data.id}`}>
				<small>{i18n`See details`}</small>
			</Link>
		</div>
	)
}

const ContextualSettingsController = () => {
	const { i18n } = useGlobal()
	const {
		contents: [usersData],
	} = useFetchList(['/users'], [User.fromJSON])

	return (
		<>
			<ExpandableWidget
				className={styles['aside-widget']}
				titleAppearance='aside-widget'
				heading='h5'
				title={i18n`Users`}
				expanded
				borderRadius
				margins={['small', '', '']}
				paddings={['', 'xsmall', 'xsmall']}
			>
				<Collection itemsHeight={28} card={UserRow} items={usersData} />
			</ExpandableWidget>
		</>
	)
}

export default ContextualSettingsController
